import ScorecardStructureModel from 'scoreboard/reports/scorecard-structure/scorecard-structure-model'
import ScorecardStructureColumnView from './scorecard-structure-columns'
import AncestorStep from '../common/ancestor-step'
import ReportFilterUtil from '../common/report-filter-util'

var ScorecardStructurePath = {
	icon: 'scorecard',
	key: 'report.scorecardStructureReport.title',
	steps: [AncestorStep, {
		titleCode: 'report.scorecardStructureReport.title',
		view: ScorecardStructureColumnView,
		validate: function(attrs, opts) {
			var c = attrs.columns || {}
			//must have one column showing, and an ancestor selected
			return !c.columns.length || !ReportFilterUtil.hasAncestorValues(attrs, 'scorecardNodeIds')
		}
	}],
	model: ScorecardStructureModel
}

export default ScorecardStructurePath

ScorecardStructurePath.__filename__ = 'reports/wizard/scorecard-structure/scorecard-structure-path.js'
